// buttonConfig.ts
import {
  DeleteOutlined,
  DownloadOutlined,
  EditOutlined,
  PlusOutlined,
  ReloadOutlined,
  SaveOutlined,
  SearchOutlined,
  UndoOutlined,
} from '@ant-design/icons';

export const BUTTON_CONFIG = {
  add: {
    code: 'add',
    text: '新增',
    icon: <PlusOutlined />,
  },
  edit: {
    code: 'edit',
    text: '编辑',
    icon: <EditOutlined />,
  },
  save: {
    code: 'save',
    text: '保存',
    icon: <SaveOutlined />,
  },
  delete: {
    code: 'delete',
    text: '删除',
    icon: <DeleteOutlined />,
    danger: true,
  },
  search: {
    code: 'search',
    text: '查询',
    icon: <SearchOutlined />,
  },
  reset: {
    code: 'reset',
    text: '重置',
    icon: <UndoOutlined />,
  },
  refresh: {
    code: 'refresh',
    text: '刷新',
    icon: <ReloadOutlined />,
  },
  export: {
    code: 'EXPORT',
    text: 'export',
    icon: <DownloadOutlined />,
  },
} as const;
